import { IconButton, IconFilters16 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

interface IFilterButtonProps {
  hasActiveFilters?: boolean;
  onClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void;
}

export const FiltersButton = ({ hasActiveFilters = false, onClick }: IFilterButtonProps) => {
  return (
    <span className={cn(styles['filters-button'], hasActiveFilters && styles['filters-button_active'])}>
      <IconButton icon={<IconFilters16 color="primary_100" />} onClick={onClick} />
    </span>
  );
};
